import { Box, Text, CloseButton, HStack } from "@chakra-ui/react"

interface PreviewBannerProps {
  previewHash: string
  onDismiss: () => void
}

export const PreviewBanner = ({ previewHash, onDismiss }: PreviewBannerProps) => {
  return (
    <Box
      position="fixed"
      bottom="4"
      right="4"
      zIndex="9999"
      bg="orange.600"
      color="white"
      borderRadius="full"
      px="4"
      py="2"
      boxShadow="lg"
    >
      <HStack gap="2">
        <Text fontSize="sm" fontWeight="semibold">
          Preview: {previewHash}
        </Text>
        <CloseButton
          size="sm"
          color="white"
          onClick={onDismiss}
          aria-label="Exit preview mode"
        />
      </HStack>
    </Box>
  )
}
